<div class="hashi-help">
  <ion-text color="primary"><h2>{{ 'HASHI.help_dialog.title' | translate }}</h2></ion-text>
  <ion-text class="intro" [innerHTML]="'HASHI.help_dialog.text' | translate"></ion-text>

  <div class="help-section">
    <ion-text color="primary"><h3>{{ 'HASHI.help_dialog.mechanics.play.title' | translate }}</h3></ion-text>
    <ion-text *ngIf="!isMobile" [innerHTML]="'HASHI.help_dialog.mechanics.play.text.desktop' | translate"></ion-text>
    <ion-text *ngIf="isMobile" [innerHTML]="'HASHI.help_dialog.mechanics.play.text.mobile' | translate"></ion-text>
  </div>

  <div class="help-section">
    <ion-text color="primary"><h3>{{ 'HASHI.help_dialog.mechanics.delete.title' | translate }}</h3></ion-text>
    <ion-text *ngIf="!isMobile" [innerHTML]="'HASHI.help_dialog.mechanics.delete.text.desktop' | translate"></ion-text>
    <ion-text *ngIf="isMobile" [innerHTML]="'HASHI.help_dialog.mechanics.delete.text.mobile' | translate"></ion-text>
  </div>
</div>
